const MathRandomPrng = {
    rand: (from, upto) => {
        // biased, not good
        let diff = upto - from;
        let n = Math.floor(Math.random() * diff);
        return from + n;
    },
    seed(_n) { },
    advance() {
        return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    },
    query_state() { return 0; }
};
const npot = (n) => {
    n -= 1;
    n |= n >> 16;
    n |= n >> 8;
    n |= n >> 4;
    n |= n >> 2;
    n |= n >> 1;
    return n + 1;
};
// TODO read paper on Xorshift: xorshift916.pdf
const makeXorshiftPrng = (seed) => {
    return {
        state: seed,
        seed(n) {
            this.state = n;
        },
        query_state() {
            return this.state;
        },
        advance() {
            this.state ^= this.state << 13;
            this.state ^= this.state >>> 17;
            this.state ^= this.state << 5;
            return this.state;
        },
        rand(from, upto) {
            // macos sierra arc4random idea
            let diff = upto - from;
            const mask = npot(diff) - 1;
            let x;
            do {
                x = this.advance() & mask;
            } while (x > diff);
            return from + x;
        }
    };
};
export default makeXorshiftPrng;
